/**
 * An error that input a person gave caused, such as a statement they wrote
 * that the engine refuses. The place that shows the error says what to
 * change, and nothing in the application is broken, so error monitoring
 * leaves it out (`shouldReportError`). An error says so by setting
 * `causedByUserInput` to true.
 */
export interface CausedByUserInput {
  readonly causedByUserInput: boolean;
}

/** Whether `error` says that input a person gave caused it
 *  (`CausedByUserInput`). */
export function isCausedByUserInput(error: unknown): boolean {
  return (
    error instanceof Error &&
    (error as Partial<CausedByUserInput>).causedByUserInput === true
  );
}
